import { render, staticRenderFns } from "./ContentBlockNotification.vue?vue&type=template&id=1b8f9987&"
import script from "./ContentBlockNotification.vue?vue&type=script&lang=js&"
export * from "./ContentBlockNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports